import * as axios from "axios";
import { OEmbedResponse, User, Video } from "vimeo";
import { videoFields } from "./fields";
import { assertSfmcParent } from "./guard";

export const client = axios.default.create({
    timeout: 20 * 1000,
});

client.interceptors.request.use((config) => {
    assertSfmcParent();
    return config;
});

client.interceptors.response.use(undefined, (err) => {
    if (err.response?.status === 401) {
        const currentPath = window.location.pathname;
        window.location.href = `/vimeo-auth?redirectUrl=${currentPath}`;
        return;
    }

    return Promise.reject(err);
});

export async function getVideo(videoId: string): Promise<Video> {
    const resp = await client.get<Video>(
        `/api/vimeo/videos/${videoId}?fields=${videoFields}`
    );

    return resp.data;
}

export async function getUser(): Promise<User> {
    const resp = await client.get<User>("/api/vimeo/user/me");
    return resp.data;
}

export async function getResponsiveOEmbed(
    videoId: string,
    hParamValue: string | null
): Promise<OEmbedResponse> {
    const url = `https://vimeo.com/${videoId}/${hParamValue || ""}`;
    const encodedUrl = encodeURIComponent(url);
    const resp = await client.get<OEmbedResponse>(
        `https://vimeo.com/api/oembed.json?url=${encodedUrl}&responsive=true`
    );

    return resp.data;
}

export const ERROR_CODE_VIDEO_NOT_FOUND_USER_DOES_NOT_OWN_VIDEO = 5000;
